import React from "react";
import { useTranslation } from "react-i18next";
import { BsPlayFill } from "react-icons/bs";
import { formatTimecode } from "../../../components/MAudioPlayer/timecode";

// Clickable "▶ 2:15" that jumps the call audio to that moment.
const TimecodeBadge = ({ seconds, on_seek, className = "" }) => {
  const { t } = useTranslation();
  const label = formatTimecode(seconds);

  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        on_seek(seconds);
      }}
      title={`${t("Listen from")} ${label}`}
      aria-label={`${t("Listen from")} ${label}`}
      className={`inline-flex items-center gap-0.5 align-baseline rounded-md bg-primary/10 px-1.5 py-px text-xs font-medium text-primary hover:bg-primary/20 transition-colors whitespace-nowrap ${className}`}
    >
      <BsPlayFill size={12} />
      {label}
    </button>
  );
};

export default TimecodeBadge;
